module.exports = __webpack_public_path__ + "img/reward.2b8d6776.svg";